import { initKioskCode } from '@/services/operations';
import React, { useState } from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

export const InitKiosk: React.FC = () => {
    const [kioskCode, setKioskCode] = useState<string>('');
    const [layoutName, setLayoutName] = useState<'default' | 'shift'>('default');

    const onChange = (value: string) => {
        setKioskCode(value);
    };

    const onKeyPress = (button: string) => {
        if (button === '{shift}' || button === '{lock}') {
            handleShift();
        }
    };
    const handleShift = () => {
        setLayoutName((prev) => (prev === 'default' ? 'shift' : 'default'));
    };

    const handleSubmit = async () => {
        const response = await initKioskCode(kioskCode);
        if (response?.data?.statusCode === 404) {
            alert(`키오스크 코드가 존재하지 않습니다.`);
        } else {
            localStorage.setItem('kioskCode', kioskCode);
            window.location.reload();
        }
    };

    return (
        <div className="flex h-screen flex-col items-center justify-center space-y-6">
            {/* Input */}
            <div className="flex space-x-3">
                <input
                    className="w-64 rounded border border-gray-400 p-2 text-center"
                    value={kioskCode}
                    placeholder="키오스크 코드를 입력하세요"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKioskCode(e.target.value)}
                />
                <button onClick={handleSubmit} className="rounded-lg bg-blue-600 px-6 py-2 text-white shadow hover:bg-blue-700">
                    제출
                </button>
            </div>

            {/* Bàn phím */}
            <Keyboard
                onChange={onChange}
                onKeyPress={onKeyPress}
                layoutName={layoutName}
                layout={{
                    default: [
                        '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
                        'q w e r t y u i o p [ ] \\',
                        "a s d f g h j k l ; ' {enter}",
                        '{shift} z x c v b n m , . / {shift}',
                        '{lock} {space}',
                    ],
                    shift: [
                        '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
                        'Q W E R T Y U I O P { } |',
                        'A S D F G H J K L : " {enter}',
                        '{shift} Z X C V B N M < > ? {shift}',
                        '{lock} {space}',
                    ],
                }}
            />
        </div>
    );
};
